import { SEGMENT_ANONYMOUS_ID_COOKIE } from "@/constants/cookies";

import { PAGE_VIEW_PROPS_GLOBAL } from "./pageViewPropsSnippet";

/**
 * Head consent default (before OtAutoBlock).
 * Seeds from OptanonConsent cookie when present (returning visitors).
 * First-time visitors stay analytics_storage:denied until OptanonWrapper updates.
 *
 * @see https://nutrafol.atlassian.net/browse/NT2-30510
 */
export const getGtagConsentDefaultSnippet = (): string => `
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
window.gtag = window.gtag || gtag;
(function () {
  var getCookie = function (n) {
    var eq = n + "=";
    var ca = document.cookie.split(";");
    for (var j = 0; j < ca.length; j++) {
      var c = ca[j];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(eq) === 0) return decodeURIComponent(c.substring(eq.length, c.length));
    }
    return null;
  };
  var groupGranted = function (groupId) {
    var raw = getCookie("OptanonConsent");
    if (!raw) return false;
    var match = raw.match(/(?:^|&)groups=([^&]*)/);
    if (!match) return false;
    var groups = decodeURIComponent(match[1]);
    return new RegExp("(^|,)" + groupId + ":1(,|$)").test(groups);
  };
  gtag("consent", "default", {
    ad_storage: groupGranted("C0004") ? "granted" : "denied",
    analytics_storage: groupGranted("C0002") ? "granted" : "denied",
    functionality_storage: groupGranted("C0003") ? "granted" : "denied",
    personalization_storage: groupGranted("C0004") ? "granted" : "denied",
    security_storage: "granted"
  });
})();
`;

/**
 * First-party GA4 gtag bootstrap (NT2-30510).
 * Config with send_page_view: false, then immediate cold-load page_view
 * (Segment pre-seed runs first in ExternalScripts so anon id cookie exists).
 */
export const getGtagConfigSnippet = (tagId: string): string => `
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
window.gtag = window.gtag || gtag;
(function(){
  try {
    gtag('js', new Date());
    gtag('config', '${tagId}', { send_page_view: false });
    if (window.__nutrafolGa4ColdPageViewSent) return;
    var getCookie = function(n){
      var eq = n + "=";
      var ca = document.cookie.split(";");
      for (var j = 0; j < ca.length; j++) {
        var c = ca[j];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(eq) === 0) return decodeURIComponent(c.substring(eq.length, c.length));
      }
      return null;
    };
    var pathname = location.pathname || "/";
    var segments = pathname.split("/").filter(Boolean);
    var isMen = segments.indexOf("men") > -1;
    var title = document.title || "";
    var name = title.split(" | ")[0] || "";
    var referrer = document.referrer || "";
    var getProps = window.${PAGE_VIEW_PROPS_GLOBAL};
    var pageProps = typeof getProps === "function" ? getProps(pathname, referrer) : {};
    var seg = getCookie("${SEGMENT_ANONYMOUS_ID_COOKIE}") || getCookie("ajs_anonymous_id") || null;
    var otGroups = typeof window.OnetrustActiveGroups === "string" ? window.OnetrustActiveGroups : "";
    var optanonGroups = typeof window.OptanonActiveGroups === "string" ? window.OptanonActiveGroups : otGroups;
    var params = {
      send_to: "${tagId}",
      page_title: title,
      page_location: location.href,
      page_path: pathname,
      page_referrer: referrer,
      previous_url: referrer,
      nutrafolBrandTag: isMen ? "men" : "master",
      user_agent_string: navigator.userAgent,
      name: name,
      page_view_count: 1
    };
    for (var k in pageProps) {
      if (pageProps[k] !== null) params[k] = pageProps[k];
    }
    if (seg) {
      params.segment_anonymous_id = seg;
    }
    if (otGroups) {
      params.OnetrustActiveGroups = otGroups;
      params.OptanonActiveGroups = optanonGroups || otGroups;
    }
    gtag("event", "page_view", params);
    window.__nutrafolGa4ColdPageViewSent = true;
  } catch (e) {}
})();
`;

export const getGtagJsSrc = (tagId: string): string => {
  const measurementPath = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_PATH;
  return measurementPath ? measurementPath : `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
};
